import { render, staticRenderFns } from "./SpeakerTest.vue?vue&type=template&id=11706409"
import script from "./SpeakerTest.vue?vue&type=script&lang=ts"
export * from "./SpeakerTest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports